/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { Box } from '.'
import { useSpring, animated } from 'react-spring'
import { PlayingCard, PlayingCardContainer, IPlayingCardProps } from './PlayingCard'

export const PlayingCardsWithAnimatedBack: React.SFC<
  IPlayingCardProps & {
    frontStyle: React.CSSProperties
    backStyle: React.CSSProperties
  }
> = ({ card, backStyle, frontStyle, ...props }) => {
  return (
    <div>
      <animated.div
        sx={{ willChange: 'transform, opacity', position: 'absolute' }}
        style={frontStyle}
      >
        <PlayingCard {...{ ...props, card }} />
      </animated.div>
      <animated.div
        sx={{ willChange: 'transform, opacity', position: 'absolute' }}
        style={backStyle}
      >
        <PlayingCardContainer sx={{ bg: 'lightGreen' }} {...props} />
      </animated.div>
    </div>
  )
}
